export default function setTopBarMargin() {
  const bodyEl = document.querySelector('body');
  const headerElHeight = document.querySelector('header.top-bar').offsetHeight;
  const format = 'px';
  bodyEl.style.marginTop = headerElHeight + format;
}
